import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getProjects = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/projects${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getProjectList = (token) =>
  axios.get(`${baseUrl}/project-list`, {
    headers: {
      authorization: token,
    },
  });

export const createProject = (data, token) =>
  axios.post(`${baseUrl}/project`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteProject = (id, token) =>
  axios.delete(`${baseUrl}/project/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateProject = (id, data, token) =>
  axios.patch(`${baseUrl}/project/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getProjectById = (id, query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/project/${id}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const getProjectsByUserId = (id, query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/projects/user/${id}${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getSitesMgmtbyProjectID = (id, token) => {

  let url = `${baseUrl}/getSitesMgmtbyProjectID/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getSiteMgmtByMgmtId = (id, token) => {
  // let qs = buildQuery(query);
  let url = `${baseUrl}/getSiteMgmtByMgmtId/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getProjectTasks = (id, token) =>
  axios.get(`${baseUrl}/project-tasks/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const getLowestLevelTask = (id, token, specific) =>
  axios.get(`${baseUrl}/lowest-tasks/${id}?personalized=${specific}`, {
    headers: {
      authorization: token,
    },
  });
